var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "t-wrapper__loader" }, [
    _c(
      "div",
      { staticClass: "t-ta--center" },
      [
        _c("Loader", { attrs: { size: "xl" } }),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "t-fs--subtitle t-mar--t-st t-fw--bold t-mar--b-mi" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("generic.text.loading_title")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "t-fs--subtitle t-mar--t-mi" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("generic.text.loading_desc")) + "\n    "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }